import { render, staticRenderFns } from "./OtherReceiptPaymentManagement.vue?vue&type=template&id=2110fcc4"
import script from "./OtherReceiptPaymentManagement.vue?vue&type=script&lang=js"
export * from "./OtherReceiptPaymentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports